import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tooltip,
  IconButton,
  Box,
  FormControl,
  TextField,
  CircularProgress
} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/Delete';


import { useSelector } from 'react-redux';
import { DialogResponsive } from './DialogResponsive';
import CloseIcon from '@material-ui/icons/Close'; import { ImagineGrid as Grid } from '../../components'
import { useDispatch } from "react-redux"
import { infraStructureActions } from './../../actions';
import { SelectAssociation } from './SelectAssociation';
import { Autocomplete } from '@material-ui/lab';
import { set, uniqueId } from 'lodash';
import { DialogCustomTitle } from '../CreateIdeaDialogs';
import { useTranslation } from 'react-i18next';



const useStyle = makeStyles((theme) => ({
  content: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalWrapper: {
    padding: "2rem",
    justifySelf: "center"
  },
  iconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  warningIcon: {
    color: "#FE9900",
    fontSize: 100,
  },
  button: {
    width: "100%"
  },
  playButton: {
    border: '0'

  },
  titleWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: 600,
    font: 'normal normal 600 20px/30px Poppins',
  },
  description: {
    textAlign: "left",
    fontSize: 16,
  },
  bodyFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: '100%',
    border: '1px solid red'
  },
  delete: {
    width: 60,
    height: 60
  },
  item: {
    display: 'flex',
  },
  selectItem: {
    margin: '0 6px'
  }
}));

export const DialogAssociationInfra = ({ open, id, handleCloseAssociationInfra, name }) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const {
    defaultAssociations,
    newAssociations,
    loadingAssociations,
    locals,
    occupationAreas
  } = useSelector(state => state.infraStructure);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(infraStructureActions.clearAssociations());
    id && dispatch(infraStructureActions.getAssociation(id));
    handleNewAssociation();
  }, [id, open]);

  function handleCloseButton() {
    handleCloseAssociationInfra();
    dispatch(infraStructureActions.clearAssociations());
  };

  function handlePostAssociations() {
    dispatch(infraStructureActions.sendUpdatedDefaultAssociation(defaultAssociations));
    dispatch(infraStructureActions.postNewAssociation(newAssociations));
    handleCloseButton();
  };

  function handleDeleteDefaultSelect(id) {
    dispatch(infraStructureActions.deleteDefaultAssociation(id));
  };

  function handleDeleteNewSelect(id) {
    dispatch(infraStructureActions.deleteNewAssociation(id));
  };

  function handleNewAssociation() {
    dispatch(infraStructureActions.setNewAssociation({
      businessUnit: {
        name,
        _id: id,
      },
      local: {
        name: '',
        _id: '',
      },
      occupationArea: {
        name: '',
        _id: ''
      },
      associationId: uniqueId()
    }));
  };

  function handleUniqueNewAssociation({ type, associationId, infra }) {
    dispatch(infraStructureActions.setUniqueNewAssociation({ type, associationId, infra }));
  };

  function handleUpdateDefaultAssociation({ type, associationId, infra }) {
    dispatch(infraStructureActions.setUpdateDefaultAssociation({ type, associationId, infra }));
  };

  function AssociationDropDowns({ local, occupationArea, associationId, handler }) {
    return (
<>
      <Grid container>
        <Grid item xs={4} className={classes.selectItem}>
          <Autocomplete
            title={local.name}
            options={locals.map(({ name, _id }) => ({ type: 'local', label: name, id: _id }))}
            getOptionLabel={(input) => input?.label}
            onChange={(_e, value) => handler({ type: 'local', associationId, infra: { name: value?.label, _id: value?.id } })}
            renderInput={(params) => (
              <TextField {...params} label="local" variant="filled" />
            )}
            value={{ type: 'local', label: local.name, id: local._id }}
          />
        </Grid>
        </Grid>
      <Grid container>
        <Grid item xs={4} className={classes.selectItem}>
          <Autocomplete
            title={occupationArea.name}
            options={occupationAreas.map(({ name, _id }) => ({ type: 'occupationArea', label: name, id: _id }))}
            getOptionLabel={(input) => input?.label}
            onChange={(_e, value) => handler({ type: 'occupationArea', associationId, infra: { name: value?.label, _id: value?.id } })}
            renderInput={(params) => (
              <TextField {...params} label="area de atuação" variant="filled" />
            )}
            value={{ type: 'occupationArea', label: occupationArea.name, id: occupationArea._id }}
          />
        </Grid>
      </Grid>

</>
    );
  };

  function RenderDropDowns() {
    return (<>
      {!!defaultAssociations.length && defaultAssociations.map(({ local, occupationArea, associationId }, index) => (<Box className={classes.item} >
        <AssociationDropDowns handler={handleUpdateDefaultAssociation} local={local} occupationArea={occupationArea} associationId={associationId} key={index} />
        <IconButton
          onClick={() => handleDeleteDefaultSelect(associationId)}
          className={classes.delete}
        >
          <Tooltip title="excluir" aria-label="excluir">
            <DeleteIcon />
          </Tooltip>
        </IconButton>
      </Box>
      ))}
      {!!newAssociations.length && newAssociations.map(({ local, occupationArea, associationId }, index) => (<Box className={classes.item} >
        <AssociationDropDowns handler={handleUniqueNewAssociation} local={local} occupationArea={occupationArea} associationId={associationId} key={index} />
        <IconButton
          onClick={() => handleDeleteNewSelect(associationId)}
          className={classes.delete}
        >
          <Tooltip title="excluir" aria-label="excluir">
            <DeleteIcon />
          </Tooltip>
        </IconButton>
      </Box>
      ))}</>
    );
  };

  return (
    <DialogResponsive open={open}>
    <DialogCustomTitle
        id="scroll-dialog-title"
        onClose={handleCloseButton}
      >
        {t('vincular_infraestrutura')}
      </DialogCustomTitle>
      <DialogContent className={classes.content}>
        <Grid container spacing={4}>
          <Box maxHeight={300}>
            <Grid item>
              <p className={classes.description}>Selecione o local e respectivas áreas de atuação a serem vinculadas à unidade <b>{`${name}.`}</b></p>
            </Grid>
            {!loadingAssociations ? <RenderDropDowns /> : <Box display='flex' justifyContent='center' alignItems='center'>
              <CircularProgress />
            </Box>}
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={4} cols={2}>
          <Grid item>
            <Button
              className={classes.playButton}
              variant="outlined"
              color="primary"
              disableElevation
              startIcon={<AddCircleIcon />}
              onClick={handleNewAssociation}
            >
              adicionar novo vínculo
            </Button>
          </Grid>
          <Grid item>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={handlePostAssociations}
            >
              salvar vínculos
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </DialogResponsive>);
}
